<!-- =========================================================================================
  File Name: clean.vue
  Description: Other Clean
========================================================================================== -->

<template>
  <div id="other-clean">
    <vx-card>
      <!-- <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="user_cash" data-day="userCash" data-time="time">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.userCash" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">会员提现</span>
          记录
        </span>
      </div> -->

      <!-- <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="user_recharge" data-day="userRecharge" data-time="time">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.userRecharge" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">会员充值</span>
          记录
        </span>
      </div> -->

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="user_log" data-day="userLog" data-time="actionTime">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.userLog" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">会员日志</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="lottery_bet" data-day="lotteryBet" data-time="actionTime">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.lotteryBet" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">彩票下注</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="lottery_zhui" data-day="lotteryZhui" data-time="actionTime">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.lotteryZhui" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">彩票追号</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="lottery_data" data-day="lotteryData" data-time="time">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.lotteryData" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">彩票开奖</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="ng_log" data-day="ngLog" data-time="betTime">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.ngLog" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">真人注单</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="admin_log" data-day="adminLog" data-time="actionTime">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.adminLog" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">管理员日志</span>
          记录
        </span>
      </div>

      <div class="flex items-center mb-5">
        <vs-button @click="clean" color="danger" size="small" data-table="activity_log" data-day="activityLog" data-time="time">清除</vs-button>
        <vs-input class="w-24 ml-2 mr-2" v-model="day.activityLog" />
        <span>
          天前的
          <span class="mr-1 ml-1 font-bold">活动日志</span>
          记录
        </span>
      </div>
    </vx-card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      day: {
        userLog: 7,
        userCash: 7,
        userRecharge: 7,
        activityLog: 7,
        adminLog: 7,
        lotteryBet: 7,
        lotteryZhui: 7,
        lotteryData: 7,
        ngLog: 7
      }
    }
  },
  methods: {
    clean (e) {
      const dataset = e.currentTarget.dataset
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.table = dataset.table
      postdata.timeName = dataset.time
      postdata.day = this.day[dataset.day]
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认开始清理数据吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('other-clean', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
          })
        }
      })
    }
  }
}
</script>
